import React, { useMemo } from 'react'

import { useItems } from '../hooks'

import ListTable from './ListTable'
import ListHeader from './ListHeader'

const List = ({ title, apiUrl, routeName, columns, sortFunc }) => {
  const [{ response: items, isLoading, error }] = useItems(apiUrl)

  const sortedItems = useMemo(() => {
    if (items && items.length && sortFunc) {
      items.sort(sortFunc)
    }
    return items
  }, [items, sortFunc])

  if (isLoading) return <div>Loading..</div>
  if (error) return <div>{error}</div>

  return (
    <>
      <ListHeader title={title} routeName={routeName} />
      <ListTable routeName={routeName} items={sortedItems} columns={columns} />
    </>
  )
}

export default List
